module.exports = __webpack_public_path__ + "img/Alfa_Bank.9248ac2c.svg";